import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import { store } from "../../../../components/VerticalLayout/store";
import {
    setLocalShop,
    setNumberMultiShopActive,
    setNumberMultiShopArchived,
    store as generalSettingStore,
    setIdsLocalShop,
    setIsAssociatedLangues,
    setShopsLanguagesData,
    setShopRowData,
    setAssociatedLanguages,
    setGlobalDataIsUpdated,
} from "../store";

import { CustomSideFilter } from "./CustomSideFilter";
import { History } from "../History";
import { LanguageAssociateModal } from "./LanguageAssociateModal";
import { ConfirmationAssociatedMessage } from "../ConfirmationAssociatedMessage";
import { ConfirmationArchiveLanguage } from "../ConfirmationArchiveLanguage";

import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";
import { store as StoreConfirmationActivationDeactivation } from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { ArrayOfCustomColumns } from "./ArrayOfCustomColumns";
import { ActiveArchiveCountShops, defaultShopState } from "../hooks";
import { useAuthHeader } from "../../../../api/headersKeycloak";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "../index.css";

export function LanguagesShop({
    setIsArchivedLanguagesClicked,
    isArchivedLanguagesClicked,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { activationDeactivationMessageModalOpened } = useSnapshot(
        StoreConfirmationActivationDeactivation
    );
    const { oneShop, userID, franchiseID, shopID } = useSnapshot(store);
    const {
        isAssociateModalOpened,
        isAssociatedLangues,
        globalDataIsUpdated,
        isValidateShopArchiveOpened,
        key,
    } = useSnapshot(generalSettingStore);
    const [shopState, setShopState] = useState(defaultShopState(shopID));
    const [modalState, setModalState] = useState({
        isHistoryModalOpened: false,
    });
    const uuidUser = localStorage.getItem("uuidUser");

    const urlArchive = `${process.env.REACT_APP_API_V2_URL}/settings/general/archived_language?userId=${userID}&franchiseId=${franchiseID}&uuidUser=${uuidUser}`;
    const urlActive = `${process.env.REACT_APP_API_V2_URL}/settings/general/language?userId=${userID}&franchiseId=${franchiseID}&uuidUser=${uuidUser}`;

    function setDataTable(data: any) {
        setShopState((prevState: any) => ({
            ...prevState,
            dataTable: data,
        }));
    }

    function setSelectedRows(data: any) {
        setShopState((prevState: any) => ({
            ...prevState,
            selectedRows: data,
        }));
    }
    function setLocalFilterActive(data: any) {
        setShopState((prevState: any) => ({
            ...prevState,
            filterActive: data,
        }));
    }
    React.useEffect(() => {
        let localShop: string[] = [];
        let idsLocalShop: string[] = [];
        let associatedLanguage: any[] = [];
        shopState.selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined)
                localShop.push(el.shopId);
            for (let i in el.subRows) {
                idsLocalShop.push(el.subRows[i].Id);
                associatedLanguage.push(el.subRows[i]);
            }
        });
        setAssociatedLanguages(associatedLanguage);
        setShopRowData(shopState.selectedRows);
        setIdsLocalShop(idsLocalShop);
        setLocalShop(localShop);
        setShopState((prevState: any) => ({
            ...prevState,
            isShopSelected: localShop.length !== 0,
        }));
        setShopsLanguagesData(shopState.dataTable.data);
        ActiveArchiveCountShops(
            shopState,
            setNumberMultiShopActive,
            setNumberMultiShopArchived
        );
        // eslint-disable-next-line
    }, [shopState.selectedRows, shopState.dataTable.data, i18nextLng]);

    return (
        <React.Fragment>
            <div>
                <DynamicTable
                    key={key}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    canMovedCheckboxLeftOnExpand
                    url={isArchivedLanguagesClicked ? urlArchive : urlActive}
                    setData={setDataTable}
                    canExpand={true}
                    canSelect
                    customSelect
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setLocalFilterActive={setLocalFilterActive}
                            setIsArchivedLanguagesClicked={
                                setIsArchivedLanguagesClicked
                            }
                            isArchivedLanguagesClicked={
                                isArchivedLanguagesClicked
                            }
                            shopState={shopState}
                            setShopState={setShopState}
                            modalState={modalState}
                            setModalState={setModalState}
                        />
                    }
                    canResize
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={shopState.filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={ArrayOfCustomColumns(
                        isArchivedLanguagesClicked,
                        shopState,
                        setShopState,
                        modalState,
                        setModalState
                    )}
                    setDataIsUpdated={
                        setGlobalDataIsUpdated as
                            | React.Dispatch<
                                  React.SetStateAction<number | boolean>
                              >
                            | undefined
                    }
                    dataIsUpdated={globalDataIsUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="language"
                />
            </div>
            {modalState.isHistoryModalOpened === true ? (
                <History
                    setTableState={setShopState}
                    tableState={shopState}
                    modalState={modalState}
                    setModalState={setModalState}
                    shops={true}
                />
            ) : null}
            {isAssociateModalOpened ? (
                <LanguageAssociateModal
                    isArchivedLanguagesClicked={isArchivedLanguagesClicked}
                />
            ) : null}
            {isAssociatedLangues && !oneShop ? (
                <ConfirmationAssociatedMessage
                    isModalOpened={isAssociatedLangues}
                    setIsModalOpened={setIsAssociatedLangues}
                />
            ) : null}
            {isValidateShopArchiveOpened ? (
                <ConfirmationArchiveLanguage
                    selectedRows={shopState.selectedRows}
                    setLimit={setLimit}
                />
            ) : null}
            {activationDeactivationMessageModalOpened && !oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
        </React.Fragment>
    );
}
